import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PatientDeleteRes;
export const PatientDeleteTodo = createAsyncThunk('PatientDelete', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `admin/patient/${id}`,
            params: {
                "company_id": localStorage.getItem('companyId')
            },
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return PatientDeleteRes = res.data
        
    } catch (error) {
        return PatientDeleteRes = error.response.data
    }
})
